import API from "../../core/apiConfig";
import { normalizePaginatedResponse } from "../../core/response";
import type { VehicleListParams, VehiclePayload } from "./types";

const getAllVehicleV2 = async (params: VehicleListParams) => {
  const response = await API.get("/admin/vehicle/v2", {
    params,
  }).then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "current");
  }

  return {
    data: [],
    totalItem: 0,
    pageSize: params.pageSize,
    current: params.current,
  };
};

const postCreateVehicleV2 = async (payload: VehiclePayload) => {
  const response = await API.post("/admin/vehicle/v2", payload).then(
    (res) => res.data,
  );
  return response;
};

const putUpdateVehicleV2 = async (id: string, payload: VehiclePayload) => {
  const response = await API.put(`/admin/vehicle/v2/${id}`, payload).then(
    (res) => res.data,
  );
  return response;
};

const deleteVehicleV2 = async (id: string) => {
  const response = await API.delete(`/admin/vehicle/v2/${id}`).then(
    (res) => res.data,
  );
  return response;
};

export default {
  getAllVehicleV2,
  postCreateVehicleV2,
  putUpdateVehicleV2,
  deleteVehicleV2,
};
